export default __webpack_public_path__ + "static/media/MS D365 - Remote Assist.24cf978f.png";